import React from 'react';

import '@app/scss/components/legendList.scss';
import { BlogTopic } from '@app/objects/Education';

interface LegendListProps {
	title: string;
	value: null | BlogTopic;
	items: Array<{
		value: string | number | undefined;
		key: string;
		label: React.ReactNode;
		item: BlogTopic;
	}>;
	multiple?: boolean;
	className?: string;
	onSelectItem?: (value) => void;
}

const LegendList: React.FC<LegendListProps> = (props) => {
	const {
		className = '', title, items, onSelectItem, value, multiple,
	} = props;
	const handleChange = (item) => {
		if (multiple) {
			if (Array.isArray(value)) {
				const set = new Set(value);
				set.has(item) ? set.delete(item) : set.add(item);
				const newArr = Array.from(set);
				onSelectItem && onSelectItem(newArr.length ? newArr : undefined);
			} else {
				onSelectItem && onSelectItem([item]);
			}
		} else {
			onSelectItem && onSelectItem(item);
		}
	};

	return <div className={`legend-list ${className}`}>
		<h3 className="legend-list__title">
			{title}
		</h3>
		<div className="legend-list__items">
			<button
				key="all"
				type="button"
				onClick={() => handleChange(null)}
				className={`inline-select-item inline-select-item_sm ${(Array.isArray(value) ? (value || []).length === 0 : !value)
					? 'inline-select-item__selected' : ''}`}
			>
				All
			</button>
			{items.map((item, i) => <button
				key={i}
				type="button"
				onClick={() => handleChange(item.item)}
				className={`inline-select-item inline-select-item_sm ${
					(Array.isArray(value) ? (value || []).some((el) => el === item.item.id) : value?.id === item.item.id)
						? 'inline-select-item__selected' : ''}`}
			>
				{item.label}
			</button>)}
		</div>
	</div>;
};

export default LegendList;
